module.exports = __webpack_public_path__ + "img/蒙版(17).9bd34e64.png";